module.exports = __webpack_public_path__ + "img/logo-spotify.38f690db.svg";